import apiService from './api';

export interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
    timestamp: string;
}

export const aiChatService = {
    async chat(message: string, history: ChatMessage[] = []): Promise<string> {
        try {
            const schoolCode = localStorage.getItem('schoolCode');
            const response = await apiService.post<{ response: string }>('/api/ai/chat', {
                message,
                history,
                school_code: schoolCode
            });

            return response.response;
        } catch (error: any) {
            console.error('AIChatService error:', error);
            const errorMessage = error?.message || 'Không thể kết nối với trợ lý AI. Vui lòng thử lại sau.';
            throw new Error(errorMessage);
        }
    },
    async syncKnowledge(): Promise<{ success: boolean; message: string }> {
        try {
            return await apiService.post<{ success: boolean; message: string }>('/api/ai/sync', {});
        } catch (error: any) {
            console.error('AIChatService sync error:', error);
            throw new Error(error?.message || 'Không thể đồng bộ tri thức AI.');
        }
    },
    async getSyncProgress(): Promise<{
        pending: number;
        processing: number;
        completed: number;
        failed: number;
        total: number;
        details?: Array<{
            filename: string;
            progress: number;
            message: string;
            status: string;
        }>;
    }> {
        try {
            return await apiService.get<any>('/api/ai/sync-progress');
        } catch (error: any) {
            console.error('AIChatService progress error:', error);
            throw new Error(error?.message || 'Không thể tải tiến độ đồng bộ.');
        }
    },
    async resetKnowledge(): Promise<{ success: boolean }> {
        try {
            return await apiService.delete<{ success: boolean }>('/api/ai/knowledge');
        } catch (error: any) {
            console.error('AIChatService reset error:', error);
            throw new Error(error?.message || 'Không thể reset tri thức AI.');
        }
    },
    // Failed tasks management
    async getFailedTasks(): Promise<any[]> {
        try {
            return await apiService.get<any[]>('/api/ai/failed-tasks');
        } catch (error: any) {
            console.error('AIChatService getFailedTasks error:', error);
            throw new Error(error?.message || 'Không thể tải danh sách file lỗi.');
        }
    },
    async retryTask(taskId: string): Promise<{ success: boolean }> {
        try {
            return await apiService.post<{ success: boolean }>('/api/ai/retry-task', { taskId });
        } catch (error: any) {
            console.error('AIChatService retryTask error:', error);
            throw new Error(error?.message || 'Retry thất bại.');
        }
    },
    async retryTasksBulk(taskIds: string[]): Promise<{ results: Array<{ taskId: string; success: boolean }> }> {
        try {
            return await apiService.post<{ results: Array<{ taskId: string; success: boolean }> }>('/api/ai/retry-tasks-bulk', { taskIds });
        } catch (error: any) {
            console.error('AIChatService retryTasksBulk error:', error);
            throw new Error(error?.message || 'Bulk retry thất bại.');
        }
    },
    async deleteFailedTask(taskId: string): Promise<{ success: boolean }> {
        try {
            return await apiService.delete<{ success: boolean }>(`/api/ai/failed-task/${taskId}`);
        } catch (error: any) {
            console.error('AIChatService deleteFailedTask error:', error);
            throw new Error(error?.message || 'Xóa task thất bại.');
        }
    }
};
